import React, { useEffect, useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";

import { IAllotAccountWriteoffDetail, IAllotAccountWriteoffFields, IAllotAccountWriteoffSearch, IAllotAccountWriteoffSearchParam } from "../../AccountTypes";
import { useDetailModel } from "../detailModel";
import { useGlobalModel } from "@/model/globalModel";
import { accountService } from "../../AccountService";
import { transPgToPagination } from "@/views/base/app/appModel";

export const useTransactModel = createModel(function () {
    const initSearchParam: IAllotAccountWriteoffSearchParam = {};
    const initDataSource: IAllotAccountWriteoffDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const { customerCode } = useDetailModel();
    const { user: { shopCode },unit } = useGlobalModel();
    
    //查询条件
    const [searchParam, setSearchParam] = useState<IAllotAccountWriteoffSearchParam>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IAllotAccountWriteoffDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IAllotAccountWriteoffDetail>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [reload, setReload] = useState(false);
    const [transactDrawerVisible, setTransactDrawerVisible] = useState(false);

    const [writeoffAmount, setWriteoffAmount] = useState<number>(0)

    
    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IAllotAccountWriteoffFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IAllotAccountWriteoffSearchParam = searchParam) => {
        const searchParams: IAllotAccountWriteoffSearch = {
            ...searchValue,
            // partnerCode: customerCode,
            status: 8,
            unitCode: unit?.code as string,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await accountService.allotWriteoffPage(searchParams);
        let { retData: totalRetData } = await accountService.allotwriteoffTotalAmount({
            unitCode: unit?.code,
            status: 8,
            ...searchValue,
        })
        const { records, ...pg } = retData;
        setWriteoffAmount(totalRetData)
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);

    }


    return {
        /***field***/
        searchParam,
        reload,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        transactDrawerVisible,
        writeoffAmount,
        /***method***/
        setDataSource,
        setReload,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setTransactDrawerVisible,
        onSearch,
        onReset,
        setSelectedData
    }
});
